import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from 'react-toolbox/lib/input';
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'

const InputComponent = ({value, onChange}) => (
  <Input
    value={value}
    onChange={onChange}
    theme={styles}
    type='text'
    hint='Search ...'
    floating={false}
  />
)

export default InputComponent
